import { combineLatest, forkJoin, Observable } from 'rxjs';
import { defaultIfEmpty } from 'rxjs/operators';

/**
 *
 * @param sources A list input streams to combine
 * @returns A list of observables combined into an observable of a list.
 * If the list of inputs is empty, it will emit an observable of an empty list
 * (unlike the regular combineLatest which will end the stream)
 */
export function combineLatestAlwaysEmit<T>(sources: Observable<T>[]): Observable<T[]> {
    return combineLatest(sources).pipe(defaultIfEmpty([] as T[]));
}

export function forkJoinAlwaysEmit<T>(sources: Observable<T>[]): Observable<T[]> {
    return forkJoin(sources).pipe(defaultIfEmpty([] as T[]));
}
